import { render, staticRenderFns } from "./SignUpExplanation.vue?vue&type=template&id=0494dc6d&lang=pug&"
import script from "./SignUpExplanation.vue?vue&type=script&lang=js&"
export * from "./SignUpExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports